module.exports = __webpack_public_path__ + "static/img/cocos2d-x.8f2374e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/cocos2d-x.jpg
// module id = SWDU
// module chunks = 1